export default "__VITE_ASSET__FQWrxfct__"